module.exports = __webpack_public_path__ + "img/image26.2cb4717e.png";